import { IPlannedPortfolioPosition } from 'src/app/models/plannedPortfolios';
import { IPortfolio, IPortfolioDataEntity, IPortfolioOption } from "src/app/models/portfolios";

export interface IPortfoliosState {
    availablePortfolios: IPortfolio[];
    selectedPortfolioEntity: IPortfolioDataEntity;
    searchPortfoliosResult: IPortfolioOption[];
    selectedPortfolioPosition: IPlannedPortfolioPosition;
    loading: boolean;
    investorReferenceNumbers: {
        [key: number]: string | null
    };

    // List of portfolios for entities.
    // TODO: Move all portfolios state objects to using this list.
    // We need a single source of truth for portfolios which is not the case at the moment.
    // At time of writing, portfolios a split between availablePortfolios and IInvestorState.details.portfolios which is not ideal.
    entitiesPortfolios: IPortfolio[];
}

export const initialPortfolioState: IPortfoliosState = {
    availablePortfolios: null,
    selectedPortfolioEntity: null,
    selectedPortfolioPosition: null,
    searchPortfoliosResult: [],
    loading: false,
    investorReferenceNumbers: {},
    entitiesPortfolios: []
};

export interface IPortfolioLoadingState {
    loading: boolean;
}